import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-reuse-confirm-dialog",
  templateUrl: "./reuse-confirm-dialog.component.html",
  styleUrls: ["./reuse-confirm-dialog.component.scss"],
  standalone: false
})
export class ReuseConfirmDialogComponent {
  firstMessage = "";
  secondMessage = "";

  constructor(
    public dialogRef: MatDialogRef<ReuseConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
